import { Typography } from '@mui/material';

export const InlineItemValue = ({ label, value }: { label: string; value: any }) => {
  return (
    <Typography color="primary">
      {label}:{' '}
      <Typography color="secondary" component="span">
        {value}
      </Typography>
    </Typography>
  );
};
